import { render } from "./SettingsInformation.vue?vue&type=template&id=27436f75&scoped=true"
import script from "./SettingsInformation.vue?vue&type=script&lang=js"
export * from "./SettingsInformation.vue?vue&type=script&lang=js"

import "./SettingsInformation.vue?vue&type=style&index=0&id=27436f75&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27436f75"]])

export default __exports__